jQuery(document).ready(function($) {

  //==========================//
  //Sticky Nav After Scrolling//
  //==========================//

  // Variables
  const $header = $('#site-header')
  const utilityNav = $('.utility-nav');
  const topBar = $(".top-bar");
  const topBarLeft = $(".top-bar-left");
  const content = $('#content');
  const $window = $(window);

  // Main Function
  function navBar() {
    if ($window.scrollTop() > utilityNav.outerHeight()) {
      $header.addClass("fixed");
      topBarLeft.addClass("fixed");
      content.addClass("fixed");
    } else {
      $header.removeClass("fixed");
      topBarLeft.removeClass("fixed");
      content.removeClass("fixed");
    }
  }

  // Call on load & scroll
  navBar();
  $window.on('scroll resize', navBar);

  // Disable On form reveal
  $(document).on('open.zf.reveal', () => {
    $window.off('scroll', navBar);
  })
  $(document).on('closed.zf.reveal', () => {
    $window.on('scroll', navBar);
  })



  //==========//
  //Mobile Nav//
  //==========//

  $(document).on('opened.zf.offcanvas', () => {
    $('.hamburger').addClass('active');
    $('body').css("overflow", "hidden");
  })
  $(document).on('closed.zf.offcanvas', () => {
    $('.hamburger').removeClass('active');
    $('body').css("overflow", "auto");
  })
  window.onresize = function() {
    if (window.innerWidth >= 958 && $('.hamburger').hasClass('active')) {
      $('body').css("overflow", "auto");
      $('.hambuger').removeClass('active');
      $('#mobile-nav').foundation('close');
    }
  }

  //=======================//
  //Dropdown Menu Animation//
  //=======================//

  $( '.is-dropdown-submenu-parent' ).on('mouseenter',
    function(){
        $(this).children('.submenu').stop().fadeIn(250);
    }
  );

  $( '.is-dropdown-submenu-parent' ).on('mouseleave',
    function(){
        $(this).children('.submenu').removeClass('js-dropdown-active').stop().fadeOut(250);
    }
  );

})
